import React, { useState } from 'react';

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import FormGroup from '@material-ui/core/FormGroup';

import FloatingButton from '../../../../components/FloatingButton';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';

const SelectMyDamages = () => {
  const { nextStep, updateSinisterBody, sinister_body } =
    useSinisterDataContext();

  const [damageDescription, setDamageDescription] = useState(
    sinister_body?.damageDescription || ''
  );

  const [state, setState] = useState({
    side_windows: sinister_body?.damage?.side_windows || false,
    windshield: sinister_body?.damage?.windshield || false,
    rear_window: sinister_body?.damage?.rear_window || false,
    lock: sinister_body?.damage?.lock || false,
    ceilings: sinister_body?.damage?.ceilings || false,
    others: sinister_body?.damage?.others || false,
  });

  const handleCheckboxChange = (event: any) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const callNextStep = () => {
    updateSinisterBody({ damage: { ...state } });
    updateSinisterBody({ damageDescription });
    nextStep();
  };

  const isDisabled = () => {
    const check = Object.values(state).some((element) => element === true);
    return !check;
  };

  const { side_windows, windshield, rear_window, lock, ceilings, others } =
    state;

  return (
    <Grid container>
      <Grid container item xs={12}>
        <Box my={3}>
          <Typography variant="h6" color="textPrimary">
            Indicanos lo que está dañado de tu auto
          </Typography>
        </Box>
      </Grid>
      <Grid container item xs={12}>
        <Box mr={2} my={2}>
          <FormControl component="fieldset">
            <FormGroup aria-label="position">
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={side_windows}
                    onChange={handleCheckboxChange}
                    name="side_windows"
                  />
                }
                label="CRISTALES LATERALES"
              />
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={windshield}
                      onChange={handleCheckboxChange}
                      name="windshield"
                    />
                  }
                  label="PARABRISAS"
                />
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={rear_window}
                      onChange={handleCheckboxChange}
                      name="rear_window"
                    />
                  }
                  label="LUNETA"
                />
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={lock}
                      onChange={handleCheckboxChange}
                      name="lock"
                    />
                  }
                  label="CERRADURA"
                />
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={ceilings}
                      onChange={handleCheckboxChange}
                      name="ceilings"
                    />
                  }
                  label="TECHOS"
                />
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={others}
                      onChange={handleCheckboxChange}
                      name="others"
                    />
                  }
                  label="OTRO"
                />
              </Box>
              <Grid item xs={12}></Grid>
            </FormGroup>
          </FormControl>
        </Box>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          {others && (
            <TextField
              inputProps={{ maxLength: 1333 }}
              size="small"
              multiline
              rows={5}
              name="origin"
              fullWidth={true}
              id="origin"
              placeholder="Me rompieron el baúl ..."
              variant="outlined"
              onChange={(event: any) =>
                setDamageDescription(event.target.value)
              }
              value={damageDescription}
              error={damageDescription.length > 1333}
              helperText={
                damageDescription.length > 1333 &&
                'La descripción de los daños no debería superar los 1333 caracteres'
              }
            />
          )}
        </Grid>
      </Grid>
      <Grid container justify="center">
        <Grid item xs={12} sm={6}>
          <FloatingButton onClick={callNextStep} disabled={isDisabled()}>
            Continuar
          </FloatingButton>
          <Box m={2}>
            <Typography>
              {' '}
              Tené en cuenta que la cobertura de daños queda sujeto a análisis
              según el tipo de cobertura.{' '}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SelectMyDamages;
